import {
  CardContainer,
  Container,
  Heading,
  Title,
  Card,
  CardTitle,
  CardDescription
} from './HowitWorks.style';

import GettingStratedCardOne from '../../../assets/images/GettingStartedCardOne.webp';
import GettingStratedCardTwo from '../../../assets/images/GettingStartedCardTwo.webp';
import GettingStratedCardThree from '../../../assets/images/GettingStartedCardThree.webp';

export const HowItWorksSection = () => {
  return (
    <Container>
      <Title>HOW IT WORKS</Title>
      <Heading>Getting started is as easy as 1,2,3...</Heading>
      <CardContainer>
        <Card>
          <img src={GettingStratedCardOne} />
          <CardTitle>Sign up on the dashboard </CardTitle>
          <CardDescription>
            Sign up on the dashboard with your email and set up withdrawal
            addresses
          </CardDescription>
        </Card>
        <Card>
          <img src={GettingStratedCardTwo} />
          <CardTitle>Select networks and tokens</CardTitle>
          <CardDescription>
            Select the network and tokens in which you wish to receive payments{' '}
          </CardDescription>
        </Card>
        <Card>
          <img src={GettingStratedCardThree} />
          <CardTitle>Start accepting payments </CardTitle>
          <CardDescription>
            Create a payment link and share with anyone to start accepting
            payments
          </CardDescription>
        </Card>
      </CardContainer>
    </Container>
  );
};
